import React, { useMemo } from 'react';
import { capitalize } from 'lodash';

import { arrayOf, shape, string } from 'prop-types';
import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropDefaults, filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import {
    EMPTY_ARRAY,
    FILTER_TITLE,
    getDefaultOptions,
    getLastType,
    getTypeFilterStateServiceFactory,
    STATE_TYPE,
} from './TypeFilterHelper';
import BaseTypeFilter from './BaseTypeFilter';

export const createTypeFilter = ({
    filterId,
    typeObjects,
    typeValues,
    getTypeNameFn,
    isAllowSelectionEmpty = false,
    maxWidth = 'sm',
    fullWidth = false,
}) => {
    const defaultOptions = getDefaultOptions(filterId, typeObjects);

    const currentOptionsArray = defaultOptions[filterId] || EMPTY_ARRAY;
    const getLastTypeFn = () => getLastType(filterId, typeValues);
    const stateServiceFactory = () =>
        getTypeFilterStateServiceFactory(FILTER_TITLE, filterId, getLastTypeFn, getTypeNameFn, isAllowSelectionEmpty);

    const TypeFilterWrapper = (props) => {
        const { state } = props;
        const currentStateArray = useMemo(() => state || typeValues, [state]);
        return (
            <BaseTypeFilter
                {...props}
                filterId={filterId}
                options={currentOptionsArray}
                state={currentStateArray}
                isAllowSelectionEmpty={isAllowSelectionEmpty}
            />
        );
    };

    TypeFilterWrapper.displayName = `${capitalize(filterId)}Filter`;

    TypeFilterWrapper.propTypes = {
        filterActions: filterPropTypes.filterActions,
        state: STATE_TYPE,
        options: shape({
            [filterId]: arrayOf(
                shape({
                    name: string,
                    value: string,
                })
            ),
        }),
    };

    TypeFilterWrapper.defaultProps = {
        ...filterPropDefaults,
        id: filterId,
        title: FILTER_TITLE,
        state: typeValues,
        isAllowSelectionEmpty: false,
        maxWidth,
        fullWidth,
    };

    return Filter({
        filterId,
        filterStateServiceFactory: stateServiceFactory(),
    })(TypeFilterWrapper);
};
